import { type ReactElement, type ReactNode } from 'react'

import { Card } from '@orus.eu/pharaoh-next/components/ui/card'

type GuaranteeListCardProps = {
  children: ReactNode
}

/** Card frame shared by `GuaranteeList` and `GuaranteeListSkeleton`, so the two cannot drift apart. */
export function GuaranteeListCard({ children }: GuaranteeListCardProps): ReactElement {
  return (
    <Card.Root className="flex flex-col gap-70 border border-line-base-basic bg-surface-base-normal-subtle p-50 shadow-none">
      {children}
    </Card.Root>
  )
}
